module.exports = __webpack_public_path__ + "img/feature-card2.2811146e.png";